module.exports = __webpack_public_path__ + "static/media/warehouse.96ec96b1.svg";